import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Web3 from 'web3';
import { MetamaskWallet, WalletConnect, getAccount } from '../Hooks/useWallet';

import { setWalletAddress } from '../lib/localStorage';
import { useDispatch, useSelector } from "react-redux";
import { getOwnerAddress } from '../Hooks/useWeb3';
import toast from 'react-hot-toast';
import WalletApp from './walletConnect/app'


const Connectwallet = ({ show, handleClose }) => {
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();
  const [owner, setOwner] = useState([]);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // await window.ethereum.request({ method: 'eth_requestAccounts' });
        const web3 = new Web3(window.ethereum);


        MetamaskWallet()
          .then(async (data) => {
            const accs = await web3.eth.getAccounts();
            console.log("🚀 ~ .then ~ accs:", accs)
            // if (accs[0].toLowerCase() != owner.toLowerCase()) {
            //   toast.error("Please Connect Admin Account")
            // }
            // else {
            toast.success("Wallet Connected Successfully")
            setAccounts(accs[0]);
            setWalletAddress(accs[0])
            dispatch({
              type: "SET_ADMINWALLET",
              payload: accs[0],
            });
            // }

          })
          .catch((e) => {
            console.log(e);
          });

      } catch (error) {
        console.error('Error connecting to Wallet:', error);
      }
    } else {
      console.error('Wallet not detected');
    }
  };

  //wallet Connect
  const enableWallet = async () => {
    try {
      setTimeout(() => handleClose(), 300);
      const provider = await WalletConnect();

      setAccounts(getAccount());
      setWalletAddress(getAccount())

      handleClose();
    } catch (e) {
      console.log("Error : ", e);
    }
  };



  const getOwner = async () => {
    try {
      let ownerAddress = await getOwnerAddress()
      console.log("🚀 ~ getOwner ~ ownerAddress:", ownerAddress)
      setOwner(ownerAddress)
    } catch (err) {
      console.log(err, "err_logout");
    }
  };


  useEffect(() => {
    getOwner()
  }, []);


  const showpopup = async () => {

  }

  return (
    // <WalletApp />

    <>
      <Modal size='sm' className='cmn_modal' centered
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >

        <Modal.Body>


          <div className='cmn_modal_header d-flex justify-content-between align-items-center'>
            <p className='cmn_modal_title'>Select Wallet</p>
            <button className='cmn_modal_closer rounded-5' onClick={handleClose}><i class="fa-solid fa-xmark" /></button>
          </div>

          <div className='d-flex align-items-center justify-content-center gap-2 mt-4 pt-2'>
            <div className='d-flex justify-content-center flex-column align-items-center  cmnModal__walletHolder' onClick={() => { connectWallet(); handleClose(); }}>
              <img src={require('../assets/images/metamask.svg').default} className='img-fluid cnctWallet__metamask' />
              <p className='wallet_title_txt mt-2 mb-0'>Metamask</p>
            </div>

            <div className='d-flex justify-content-center flex-column align-items-center  cmnModal__walletHolder' onClick={() => { connectWallet(); handleClose(); }}>
              <img src={require('../assets/images/trustwallet.svg').default} className='img-fluid cnctWallet__metamask' />
              <p className='wallet_title_txt mt-2 mb-0'>Trust Wallet</p>
            </div>

            <div className='d-flex justify-content-center flex-column align-items-center cmnModal__walletHolder' onClick={() => { enableWallet(); handleClose(); }}>
              <img src={require('../assets/images/walletconnect.svg').default} className='img-fluid cnctWallet__metamask' />
              <p className='wallet_title_txt mt-2 mb-0'>Wallet Connect</p>
            </div>


          </div>
          <div className='d-flex align-items-center flex-column justify-content-center gap-3 mt-4 cnt_wallet_btns' >
            {/* <WalletApp /> */}

          </div>
        </Modal.Body>

      </Modal>
    </>


    // <>
    //   <Modal size='md' className='cmn_modal' centered
    //     show={show}
    //     onHide={handleClose}
    //     backdrop="static"
    //     keyboard={false}
    //   >

    //     <Modal.Body>


    //       <div className='cmn_modal_header d-flex justify-content-between align-items-center'>
    //         <p className='cmn_modal_title'>Select Wallet</p>
    //         <button className='cmn_modal_closer rounded-5' onClick={handleClose}><i class="fa-solid fa-xmark" /></button>
    //       </div>

    //       <div className='d-flex align-items-center justify-content-center gap-4 mt-4'>
    //         <div className='d-flex justify-content-center flex-column align-items-center  cmnModal__walletHolder' onClick={() => { connectWallet(); handleClose(); }}>
    //           <img src={require('../assets/images/metamask.svg').default} className='img-fluid cnctWallet__metamask' />
    //           <p className='wallet_title_txt mt-2'>Metamask</p>
    //         </div>

    //         <div className='d-flex justify-content-center flex-column align-items-center  cmnModal__walletHolder' onClick={() => { connectWallet(); handleClose(); }}>
    //           <img src={require('../assets/images/trustwallet.svg').default} className='img-fluid cnctWallet__metamask' />
    //           <p className='wallet_title_txt mt-2'>Trust Wallet</p>
    //         </div>

    //         <div className='d-flex justify-content-center flex-column align-items-center cmnModal__walletHolder' onClick={() => { enableWallet(); handleClose(); }}>
    //           <img src={require('../assets/images/walletconnect.svg').default} className='img-fluid cnctWallet__metamask' />
    //           <p className='wallet_title_txt mt-2'>Wallet Connect</p>
    //         </div>

    //       </div>
    //     </Modal.Body>

    //   </Modal>
    // </>
  )
}

export default Connectwallet